import { Environment, getEnvironment } from 'utils/environment'

const hostByEnvironment: Record<Environment, string> = {
  [Environment.TacticProd]: 'https://app.choosetactic.com',
  [Environment.Prod]: 'https://accounting.taxbit.com',
  [Environment.TacticStage]: 'https://stage.choosetactic.com',
  [Environment.Staging]: 'https://staging.accounting.taxbit.com',
  [Environment.Local]: 'http://localhost:5000',
  [Environment.Zeus]: '',
  [Environment.Other]: window.location.origin,
}

const getEndpointUrl = (path: string, shouldIncludeApiPrefix = true) => {
  const environment = getEnvironment()
  const host = hostByEnvironment[environment]
  return `${host}${shouldIncludeApiPrefix ? '/api/' : '/'}${path}`
}

export default getEndpointUrl
